const SimularPrecoItemOrcamentoController = ControllerBase.extend({ /*FNX- 5311*/
    name: "SimulacaoPrecoItemOrcamentoController",
    framework: "knockout",

    ajax: function () {
        return {
            url: "/Orcamento/_SimularPrecoItemOrcamento",
            type: "post",
            cache: false
        };
    },

    events: {
        'keyup #simularPrecoItem_Senha': 'validarSenhaPermissao_keyUp',
        'click #entrar-simularPrecoItem_Senha': 'validarSenhaPermissao',
        'click #simulacaoPrecoItem-calcularPreco': 'calcularSimulacaoPreco',
        'click #simulacaoPrecoItem-incluir': 'incluirComposicao',
        'click #simulacaoPrecoItem-excluir': 'excluirComposicao',
        'click #simulacaoPrecoItem-excluir': 'aplicarNoOrcamento',
    },

    validarSenhaPermissao_keyUp: function (e) {
        if (e.keyCode === 13) {
            e.preventDefault();
            this.validarSenhaPermissao(e);
        }
    },

    validarSenhaPermissao: function (e) {
        e.preventDefault();

        var self = this;
        var senha = $("#simularPrecoItem_Senha").val()
        global.blockUI();
        global.ajax({
            url: '/Orcamento/ValidarPermissaoSenhaVenda',
            type: 'post',
            blockUI: true,
            data: {
                senha: senha,
                permissao: 'TIPO_LIBERACAO_LIBERASIMULACAOPESQUISAORC',
            },
            error: function () {
                
                global.unblockUI();
                global.showDefaultErrorMessage();

            },
            success: function (data) {

                if (data && data === true) {
                    self.Simular();
                }
                else {
                    global.unblockUI();
                }

                // @TODO remover
                self.Simular()
            }
        });

    },

    Simular: function () { // fnx-5311

        self = this;
        global.blockUI();
        global.ajax({
            url: '/Orcamento/SimularPrecoItemOrcamento',
            type: 'post',
            blockUI: true,
            data: {
                identificadorOrcamento: self.identificadorOrcamento,
                identificador: this.identificador,
            },
            error: function () {
                global.unblockUI();
                global.showDefaultErrorMessage();
            },
            success: function (data) {
                if (data) {
                    self.setModel(data);
                    self.applyBindings();

                    $("#simulacaoPrecoItem-fieldSet-Senha").hide();
                    $("#simulacaoPrecoItem-fieldSet-simulacao").show();
                }
                else {
                    global.showErrorMessage("Não foi possível obter a simulação de preço do produto.");
                    global.unblockUI();
                }
            }
        });
    },

    antesBinding: function () {
        $("#simulacaoPrecoItem-fieldSet-simulacao").hide();
    },

    aposBinding: function () {

        $("input").on('focus', function () { $(this).select(); });
        $("textarea").on('focus', function () { $(this).select(); });
    },

    calcularSimulacaoPreco: function () { // fnx-5311
        self = this;
        var simulacao = ko.mapping.toJS(this.model);

        global.blockUI();
        global.ajax({
            url: '/Orcamento/CalcularSimulacaoPreco',
            type: 'post',
            blockUI: true,
            data: {
                identificadorOrcamento: self.identificadorOrcamento,
                identificador: this.identificador,
                model: simulacao,
            },
            error: function () {
                global.unblockUI();
                global.showDefaultErrorMessage();
            },
            success: function (data) {
                if (data) {
                    self.setModel(data);
                    self.applyBindings();
                }
                else {
                    global.showErrorMessage("Não foi possível obter a simulação de preço do produto.");
                    global.unblockUI();
                }
            }
        });
    },

    incluirComposicao: function () {

    },

    excluirComposicao: function () {

    },

    aplicarNoOrcamento: function () {

        //var self = this;

        //var lote = this.toJS(this.model.Lote());
        //lote.QuantidadeReservar = $("#editarLoteProduto_QuantidadeReservar").val(); // FNX-5571

        //lote.CodigoObjetoItemOrcamento = this.codigoObjetoItemOrcamento;

        //global.ajax({
        //    url: "/Orcamento/ReservarLote",
        //    type: "post",
        //    data: {
        //        identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento"),
        //        lote: lote
        //    },
        //    success: function (data) {

        //        if (!data) {
        //            return;
        //        }

        //        if (!data.HasErrors) {

        //            self.produto.QuantidadeReservada(data.QuantidadeReservada);
        //            self.orcamento.atualizarItem(data.ItensOrcamento);

        //            var m = ko.mapping.fromJS(data.Lotes.Entities);

        //            self.produto.Lotes().Entities(m());

        //            global.showSuccessMessage("Lote reservado com sucesso");

        //            if (self.finalizarCallback) {
        //                self.finalizarCallback();
        //            }
        //        } else {

        //            self.model.Lote().QuantidadeReservar(data.QuantidadeReservar);

        //        }

        //    }
        //});

    }



})

window.SimularPrecoItemOrcamentoController = SimularPrecoItemOrcamentoController

export {
    SimularPrecoItemOrcamentoController
}